<template>
  <GwMenu
    class="h-100 d-flex"
    trigger="hover"
    placement="bottom"
    :flOptions="{ offset: 0, padding: 0 }"
  >
    <template #opener>
      <router-link
        class="h-100"
        :to="{ name: 'AnalyzeOriginal' }"
      >
        <NavCard
          :item="links_menu[3]"
          class="navcard_menu navcard_menu-trigger navcard_router-link"
          :style="'--clr-text:var(--clr-grey-2); --padding: 0 1rem;'"
          :hasSub="false"
        />
      </router-link>
    </template>
    <template #default="{ methods }">
      <div
        class="gw_menu"
        style="padding: 0"
        @click="methods.toggleOpen(false)"
      >
        <div class="app-group-menu">
          <router-link
            v-for="item in topLinks"
            :key="item.pathName"
            :to="{ name: item.pathName }"
          >
            <NavCard
              :item
              :hasIcon="false"
              :hasTitleIcon="true"
              class="navcard_menu navcard_reversed_l text-nowrap navcard_router-link"
              :hasTag="!!item.tag"
              :style="item.style"
              @click="
                e => {
                  if (item.pathName === $route.name) {
                    links_clickPreventLocalNav(e)
                  }
                }
              "
            />
          </router-link>
        </div>
        <div
          v-if="!$i18n.g1"
          class="bt-grey w-100 d-flex"
          style="grid-column: 1/-1"
        >
          <LinkGuide
            class="ml-auto px-4 py-2"
            :link="links_url_links.analyze_guide.url"
            :text="links_url_links.analyze_guide.text"
            @click.stop
          />
        </div>
      </div>
    </template>
  </GwMenu>
</template>

<script>
import LinkGuide from '@/components/AppBar/LinkGuide'
import GwMenu from '@/components/lib/GwMenu'
import links_mix from '@/mixins/links_mix'

export default {
  name: 'AnalyzeMenu',
  components: {
    LinkGuide,
    GwMenu,
  },
  mixins: [links_mix],
  computed: {
    topLinks() {
      const topLinks = this.links_analyze_v4

      return [
        ...topLinks,
        ...(this.$store.getters.user_has_flag('GTO_REP') ? [this.links_all.GtoReports] : []),
        ...(this.$store.getters.user_has_flag('HANDS_V4') ? [this.links_all.AnalyzeHandsV4] : []),
      ]
    },
  },
}
</script>
